import { render, staticRenderFns } from "./CompanyStatisticsChart.vue?vue&type=template&id=c0907ccc&"
import script from "./CompanyStatisticsChart.vue?vue&type=script&lang=js&"
export * from "./CompanyStatisticsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CompanyStatisticsChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c0907ccc')) {
      api.createRecord('c0907ccc', component.options)
    } else {
      api.reload('c0907ccc', component.options)
    }
    module.hot.accept("./CompanyStatisticsChart.vue?vue&type=template&id=c0907ccc&", function () {
      api.rerender('c0907ccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/company-settings/CompanyStatisticsChart.vue"
export default component.exports